import { Component } from '@angular/core';
import { ClientService } from '../../../../services/client.service';
import { CognitoService } from '../../../../services/cognito.service';
import { firstValueFrom } from 'rxjs';
import { ClientUserExportFormComponent } from '../../../forms/standard/client-user-export-form/client-user-export-form.component';
import { NavigationService } from '../../../../services/navigation.service';

@Component({
	selector: 'app-client-user-export',
	standalone: true,
	imports: [ClientUserExportFormComponent],
	templateUrl: './client-user-export.component.html',
	styleUrl: './client-user-export.component.scss',
})
export class ClientUserExportComponent {
	constructor(
		private clientService: ClientService,
		private cognitoService: CognitoService,
		private nav: NavigationService
	) {}

	public async exportUsers$(formPayload: any): Promise<void> {
		const params: Record<string, string> = await firstValueFrom(this.nav.matrixParams$);

		const clientUuid: string = params['clientUuid'];
		const userPoolId: string = formPayload.userPoolId;

		return this.clientService.exportClientUsers$(clientUuid, userPoolId);
	}
}
